import { Route, Routes } from 'react-router-dom';
import SelfService from './index';
import AuthenticatorList from '@selfservice/containers/AuthenticatorList';
import AuthMethodLayout from '@selfservice/containers/AuthMethods/AuthMethodLayout';
import FaceCapture from '@selfservice/containers/AuthMethods/FaceCapture/FaceCapture';
import IdentityPassword from '@selfservice/containers/AuthMethods/IdentityPassword/IdentityPassword';

import SelfServiceHorizontal from '@assets/ss_graphic_horizontal.svg';
import SelfServiceVertical from '@assets/ss_graphic_vertical.svg';
import PasswordImg from '@assets/uss_password_authenticator.svg?react';

export enum SelfServicePath {
  SELF_SERVICE_LANDING_PAGE = '/self-service',
  SELF_SERVICE_ENROLL_FACE = '/face/enroll',
  SELF_SERVICE_IDENTITY_PASSWORD = '/password',
}

const SelfServiceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SelfService />}>
        <Route index element={<AuthenticatorList />} />

        <Route
          path={SelfServicePath.SELF_SERVICE_ENROLL_FACE}
          element={
            <AuthMethodLayout  graphic={
               <>
                 <img src={SelfServiceVertical} alt="Desktop" className="left-panel-image-desktop" />
                 <img src={SelfServiceHorizontal} alt="Mobile" className="left-panel-image-mobile" />
               </>
             }>
              <FaceCapture />
            </AuthMethodLayout>
          }
        />

        <Route
          path={SelfServicePath.SELF_SERVICE_IDENTITY_PASSWORD}
          element={
            <AuthMethodLayout graphic={<PasswordImg />}>
              <IdentityPassword />
            </AuthMethodLayout>
          }
        />
      </Route>
    </Routes>
  );
};

export default SelfServiceRoutes;
